// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
/*
 *  Owl Carousel - Core
 */
.B3tEJdr_KmLFaZ7vY9gK {
  display: none;
  width: 100%;
  -webkit-tap-highlight-color: transparent;
  /* position relative and z-index fix webkit rendering fonts issue */
  position: relative;
  z-index: 1; }
  .B3tEJdr_KmLFaZ7vY9gK .rqibDv2_vRHE6I6twseA {
    position: relative;
    -ms-touch-action: pan-Y;
    touch-action: manipulation;
    -moz-backface-visibility: hidden;
    /* fix firefox animation glitch */ }
  .B3tEJdr_KmLFaZ7vY9gK .rqibDv2_vRHE6I6twseA:after {
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0; }
  .B3tEJdr_KmLFaZ7vY9gK .Vt4F27Q6UR6R4zawpPQ_ {
    position: relative;
    overflow: hidden;
    /* fix for flashing background */
    -webkit-transform: translate3d(0px, 0px, 0px); }
  .B3tEJdr_KmLFaZ7vY9gK .cA0_RRkLIdtrfIB7S_bS,
  .B3tEJdr_KmLFaZ7vY9gK .L5aN98P53zRyoIWKZuAs {
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -ms-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0); }
  .B3tEJdr_KmLFaZ7vY9gK .L5aN98P53zRyoIWKZuAs {
    position: relative;
    min-height: 1px;
    float: left;
    -webkit-backface-visibility: hidden;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none; }
  .B3tEJdr_KmLFaZ7vY9gK .L5aN98P53zRyoIWKZuAs img {
    display: block;
    width: 100%; }
  .B3tEJdr_KmLFaZ7vY9gK .A2s7YkRO91_G6EsHQEiw.o1Gs3P4PrgoHL5PovjaA,
  .B3tEJdr_KmLFaZ7vY9gK .RDzi78HOVApKulG9aCvS.o1Gs3P4PrgoHL5PovjaA {
    display: none; }
  .B3tEJdr_KmLFaZ7vY9gK .A2s7YkRO91_G6EsHQEiw .UJuyBGg2TPXN0nzD9WxX,
  .B3tEJdr_KmLFaZ7vY9gK .A2s7YkRO91_G6EsHQEiw .MLh4lbJ0oIjw6LcTQrj6,
  .B3tEJdr_KmLFaZ7vY9gK .gu6IfuekKMaNPXHPVqdA {
    cursor: pointer;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none; }
  .B3tEJdr_KmLFaZ7vY9gK .A2s7YkRO91_G6EsHQEiw button.UJuyBGg2TPXN0nzD9WxX,
  .B3tEJdr_KmLFaZ7vY9gK .A2s7YkRO91_G6EsHQEiw button.MLh4lbJ0oIjw6LcTQrj6,
  .B3tEJdr_KmLFaZ7vY9gK button.gu6IfuekKMaNPXHPVqdA {
    background: none;
    color: inherit;
    border: none;
    padding: 0 !important;
    font: inherit; }
  .B3tEJdr_KmLFaZ7vY9gK.fT2_4Ur6_IX0kr8iKnhW {
    display: block; }
  .B3tEJdr_KmLFaZ7vY9gK.S746yUyz14DtrJDee0yF {
    opacity: 0;
    display: block; }
  .B3tEJdr_KmLFaZ7vY9gK.UuWfO3p7YRBdAfxn9eaV {
    opacity: 0; }
  .B3tEJdr_KmLFaZ7vY9gK.Rr8eeVZuElw8JipvJqpg .L5aN98P53zRyoIWKZuAs {
    visibility: hidden; }
  .B3tEJdr_KmLFaZ7vY9gK.kg8MESfbc0ZhDQyMJONa .L5aN98P53zRyoIWKZuAs {
    -ms-touch-action: pan-y;
        touch-action: pan-y;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none; }
  .B3tEJdr_KmLFaZ7vY9gK.QSJrOCVkk_dfdBWJ7ZGX {
    cursor: move;
    cursor: grab; }
  .B3tEJdr_KmLFaZ7vY9gK.cgmhjPurAiyctTFQMHob {
    direction: rtl; }
  .B3tEJdr_KmLFaZ7vY9gK.cgmhjPurAiyctTFQMHob .L5aN98P53zRyoIWKZuAs {
    float: right; }

/* No Js */
.Zc_Zvfe3zVHf4rCtRKXK .B3tEJdr_KmLFaZ7vY9gK {
  display: block; }

/*
 *  Owl Carousel - Animate Plugin
 */
.B3tEJdr_KmLFaZ7vY9gK .O4jEbqUoMsMgES7MgIJM {
  animation-duration: 1000ms;
  animation-fill-mode: both; }

.B3tEJdr_KmLFaZ7vY9gK .mOcxFSEmUSK9R1SH5Feq {
  z-index: 0; }

.B3tEJdr_KmLFaZ7vY9gK .RtO3k04E9KCvvCN9L818 {
  z-index: 1; }

.B3tEJdr_KmLFaZ7vY9gK .CVOqo4lluffqdzHTa5N9 {
  animation-name: CVOqo4lluffqdzHTa5N9; }

@keyframes CVOqo4lluffqdzHTa5N9 {
  0% {
    opacity: 1; }
  100% {
    opacity: 0; } }

/*
 * 	Owl Carousel - Auto Height Plugin
 */
.NnQunEmKA6U2q6b9KHSW {
  transition: height 500ms ease-in-out; }

/*
 * 	Owl Carousel - Lazy Load Plugin
 */
.B3tEJdr_KmLFaZ7vY9gK .L5aN98P53zRyoIWKZuAs {
  /**
			This is introduced due to a bug in IE11 where lazy loading combined with autoheight plugin causes a wrong
			calculation of the height of the owl-item that breaks page layouts
		 */ }
  .B3tEJdr_KmLFaZ7vY9gK .L5aN98P53zRyoIWKZuAs .NW2yF1eMMwUNRoC7_rxi {
    opacity: 0;
    transition: opacity 400ms ease; }
  .B3tEJdr_KmLFaZ7vY9gK .L5aN98P53zRyoIWKZuAs .NW2yF1eMMwUNRoC7_rxi[src^=""], .B3tEJdr_KmLFaZ7vY9gK .L5aN98P53zRyoIWKZuAs .NW2yF1eMMwUNRoC7_rxi:not([src]) {
    max-height: 0; }
  .B3tEJdr_KmLFaZ7vY9gK .L5aN98P53zRyoIWKZuAs img.NW2yF1eMMwUNRoC7_rxi {
    transform-style: preserve-3d; }

/*
 * 	Owl Carousel - Video Plugin
 */
.B3tEJdr_KmLFaZ7vY9gK .CwtzI924oJiPSR9HkJNQ {
  position: relative;
  height: 100%;
  background: #000; }

.B3tEJdr_KmLFaZ7vY9gK .wy8hu_64Gnr9hFUrOdZ8 {
  position: absolute;
  height: 80px;
  width: 80px;
  left: 50%;
  top: 50%;
  margin-left: -40px;
  margin-top: -40px;
  /* background: url("owl.video.play.png") no-repeat; */
  cursor: pointer;
  z-index: 1;
  -webkit-backface-visibility: hidden;
  transition: transform 100ms ease; }

.B3tEJdr_KmLFaZ7vY9gK .wy8hu_64Gnr9hFUrOdZ8:hover {
  -ms-transform: scale(1.3, 1.3);
      transform: scale(1.3, 1.3); }

.B3tEJdr_KmLFaZ7vY9gK .RdoAZGeSJrcnhV0L_4U8 .kCfjmK1m4zcKS7GlfPyD,
.B3tEJdr_KmLFaZ7vY9gK .RdoAZGeSJrcnhV0L_4U8 .wy8hu_64Gnr9hFUrOdZ8 {
  display: none; }

.B3tEJdr_KmLFaZ7vY9gK .kCfjmK1m4zcKS7GlfPyD {
  opacity: 0;
  height: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  transition: opacity 400ms ease; }

.B3tEJdr_KmLFaZ7vY9gK .pUWxxEZ962T5GBqLGgay {
  position: relative;
  z-index: 1;
  height: 100%;
  width: 100%; }
`, "",{"version":3,"sources":["webpack://./Features/Shared/Widgets/DataCarousel/Assets/owl.carousel.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;;EAEE;AACF;EACE,aAAa;EACb,WAAW;EACX,wCAAwC;EACxC,mEAAmE;EACnE,kBAAkB;EAClB,UAAU,EAAE;EACZ;IACE,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,gCAAgC;IAChC,iCAAiC,EAAE;EACrC;IACE,YAAY;IACZ,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,SAAS,EAAE;EACb;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,6CAA6C,EAAE;EACjD;;IAEE,mCAAmC;IACnC,gCAAgC;IAChC,+BAA+B;IAC/B,uCAAuC;IACvC,oCAAoC;IACpC,mCAAmC,EAAE;EACvC;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mCAAmC;IACnC,wCAAwC;IACxC,2BAA2B,EAAE;EAC/B;IACE,cAAc;IACd,WAAW,EAAE;EACf;;IAEE,aAAa,EAAE;EACjB;;;IAGE,eAAe;IACf,yBAAyB;IACzB,wBAAwB;IACxB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB,EAAE;EACrB;;;IAGE,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,aAAa,EAAE;EACjB;IACE,cAAc,EAAE;EAClB;IACE,UAAU;IACV,cAAc,EAAE;EAClB;IACE,UAAU,EAAE;EACd;IACE,kBAAkB,EAAE;EACtB;IACE,uBAAuB;QACnB,mBAAmB;IACvB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB,EAAE;EACrB;IACE,YAAY;IACZ,YAAY,EAAE;EAChB;IACE,cAAc,EAAE;EAClB;IACE,YAAY,EAAE;;AAElB,UAAU;AACV;EACE,cAAc,EAAE;;AAElB;;EAEE;AACF;EACE,0BAA0B;EAC1B,yBAAyB,EAAE;;AAE7B;EACE,UAAU,EAAE;;AAEd;EACE,UAAU,EAAE;;AAEd;EACE,oCAAuB,EAAE;;AAE3B;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;;EAEE;AACF;EACE,oCAAoC,EAAE;;AAExC;;EAEE;AACF;EACE;;;IAGE,EAAE;EACJ;IACE,UAAU;IACV,8BAA8B,EAAE;EAClC;IACE,aAAa,EAAE;EACjB;IACE,4BAA4B,EAAE;;AAElC;;EAEE;AACF;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,qDAAqD;EACrD,eAAe;EACf,UAAU;EACV,mCAAmC;EACnC,gCAAgC,EAAE;;AAEpC;EACE,8BAA8B;MAC1B,0BAA0B,EAAE;;AAElC;;EAEE,aAAa,EAAE;;AAEjB;EACE,UAAU;EACV,YAAY;EACZ,kCAAkC;EAClC,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B,EAAE;;AAElC;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW,EAAE","sourcesContent":["/**\n * Owl Carousel v2.3.4\n * Copyright 2013-2018 David Deutsch\n * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE\n */\n/*\n *  Owl Carousel - Core\n */\n.owl-carousel {\n  display: none;\n  width: 100%;\n  -webkit-tap-highlight-color: transparent;\n  /* position relative and z-index fix webkit rendering fonts issue */\n  position: relative;\n  z-index: 1; }\n  .owl-carousel .owl-stage {\n    position: relative;\n    -ms-touch-action: pan-Y;\n    touch-action: manipulation;\n    -moz-backface-visibility: hidden;\n    /* fix firefox animation glitch */ }\n  .owl-carousel .owl-stage:after {\n    content: \".\";\n    display: block;\n    clear: both;\n    visibility: hidden;\n    line-height: 0;\n    height: 0; }\n  .owl-carousel .owl-stage-outer {\n    position: relative;\n    overflow: hidden;\n    /* fix for flashing background */\n    -webkit-transform: translate3d(0px, 0px, 0px); }\n  .owl-carousel .owl-wrapper,\n  .owl-carousel .owl-item {\n    -webkit-backface-visibility: hidden;\n    -moz-backface-visibility: hidden;\n    -ms-backface-visibility: hidden;\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0); }\n  .owl-carousel .owl-item {\n    position: relative;\n    min-height: 1px;\n    float: left;\n    -webkit-backface-visibility: hidden;\n    -webkit-tap-highlight-color: transparent;\n    -webkit-touch-callout: none; }\n  .owl-carousel .owl-item img {\n    display: block;\n    width: 100%; }\n  .owl-carousel .owl-nav.disabled,\n  .owl-carousel .owl-dots.disabled {\n    display: none; }\n  .owl-carousel .owl-nav .owl-prev,\n  .owl-carousel .owl-nav .owl-next,\n  .owl-carousel .owl-dot {\n    cursor: pointer;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n  .owl-carousel .owl-nav button.owl-prev,\n  .owl-carousel .owl-nav button.owl-next,\n  .owl-carousel button.owl-dot {\n    background: none;\n    color: inherit;\n    border: none;\n    padding: 0 !important;\n    font: inherit; }\n  .owl-carousel.owl-loaded {\n    display: block; }\n  .owl-carousel.owl-loading {\n    opacity: 0;\n    display: block; }\n  .owl-carousel.owl-hidden {\n    opacity: 0; }\n  .owl-carousel.owl-refresh .owl-item {\n    visibility: hidden; }\n  .owl-carousel.owl-drag .owl-item {\n    -ms-touch-action: pan-y;\n        touch-action: pan-y;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n  .owl-carousel.owl-grab {\n    cursor: move;\n    cursor: grab; }\n  .owl-carousel.owl-rtl {\n    direction: rtl; }\n  .owl-carousel.owl-rtl .owl-item {\n    float: right; }\n\n/* No Js */\n.no-js .owl-carousel {\n  display: block; }\n\n/*\n *  Owl Carousel - Animate Plugin\n */\n.owl-carousel .animated {\n  animation-duration: 1000ms;\n  animation-fill-mode: both; }\n\n.owl-carousel .owl-animated-in {\n  z-index: 0; }\n\n.owl-carousel .owl-animated-out {\n  z-index: 1; }\n\n.owl-carousel .fadeOut {\n  animation-name: fadeOut; }\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n/*\n * \tOwl Carousel - Auto Height Plugin\n */\n.owl-height {\n  transition: height 500ms ease-in-out; }\n\n/*\n * \tOwl Carousel - Lazy Load Plugin\n */\n.owl-carousel .owl-item {\n  /**\n\t\t\tThis is introduced due to a bug in IE11 where lazy loading combined with autoheight plugin causes a wrong\n\t\t\tcalculation of the height of the owl-item that breaks page layouts\n\t\t */ }\n  .owl-carousel .owl-item .owl-lazy {\n    opacity: 0;\n    transition: opacity 400ms ease; }\n  .owl-carousel .owl-item .owl-lazy[src^=\"\"], .owl-carousel .owl-item .owl-lazy:not([src]) {\n    max-height: 0; }\n  .owl-carousel .owl-item img.owl-lazy {\n    transform-style: preserve-3d; }\n\n/*\n * \tOwl Carousel - Video Plugin\n */\n.owl-carousel .owl-video-wrapper {\n  position: relative;\n  height: 100%;\n  background: #000; }\n\n.owl-carousel .owl-video-play-icon {\n  position: absolute;\n  height: 80px;\n  width: 80px;\n  left: 50%;\n  top: 50%;\n  margin-left: -40px;\n  margin-top: -40px;\n  /* background: url(\"owl.video.play.png\") no-repeat; */\n  cursor: pointer;\n  z-index: 1;\n  -webkit-backface-visibility: hidden;\n  transition: transform 100ms ease; }\n\n.owl-carousel .owl-video-play-icon:hover {\n  -ms-transform: scale(1.3, 1.3);\n      transform: scale(1.3, 1.3); }\n\n.owl-carousel .owl-video-playing .owl-video-tn,\n.owl-carousel .owl-video-playing .owl-video-play-icon {\n  display: none; }\n\n.owl-carousel .owl-video-tn {\n  opacity: 0;\n  height: 100%;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  transition: opacity 400ms ease; }\n\n.owl-carousel .owl-video-frame {\n  position: relative;\n  z-index: 1;\n  height: 100%;\n  width: 100%; }\n"],"sourceRoot":""}]);
// Exports
var _1 = `B3tEJdr_KmLFaZ7vY9gK`;
export { _1 as "owl-carousel" };
var _2 = `rqibDv2_vRHE6I6twseA`;
export { _2 as "owl-stage" };
var _3 = `Vt4F27Q6UR6R4zawpPQ_`;
export { _3 as "owl-stage-outer" };
var _4 = `cA0_RRkLIdtrfIB7S_bS`;
export { _4 as "owl-wrapper" };
var _5 = `L5aN98P53zRyoIWKZuAs`;
export { _5 as "owl-item" };
var _6 = `A2s7YkRO91_G6EsHQEiw`;
export { _6 as "owl-nav" };
export var disabled = `o1Gs3P4PrgoHL5PovjaA`;
var _7 = `RDzi78HOVApKulG9aCvS`;
export { _7 as "owl-dots" };
var _8 = `UJuyBGg2TPXN0nzD9WxX`;
export { _8 as "owl-prev" };
var _9 = `MLh4lbJ0oIjw6LcTQrj6`;
export { _9 as "owl-next" };
var _a = `gu6IfuekKMaNPXHPVqdA`;
export { _a as "owl-dot" };
var _b = `fT2_4Ur6_IX0kr8iKnhW`;
export { _b as "owl-loaded" };
var _c = `S746yUyz14DtrJDee0yF`;
export { _c as "owl-loading" };
var _d = `UuWfO3p7YRBdAfxn9eaV`;
export { _d as "owl-hidden" };
var _e = `Rr8eeVZuElw8JipvJqpg`;
export { _e as "owl-refresh" };
var _f = `kg8MESfbc0ZhDQyMJONa`;
export { _f as "owl-drag" };
var _10 = `QSJrOCVkk_dfdBWJ7ZGX`;
export { _10 as "owl-grab" };
var _11 = `cgmhjPurAiyctTFQMHob`;
export { _11 as "owl-rtl" };
var _12 = `Zc_Zvfe3zVHf4rCtRKXK`;
export { _12 as "no-js" };
export var animated = `O4jEbqUoMsMgES7MgIJM`;
var _13 = `mOcxFSEmUSK9R1SH5Feq`;
export { _13 as "owl-animated-in" };
var _14 = `RtO3k04E9KCvvCN9L818`;
export { _14 as "owl-animated-out" };
export var fadeOut = `CVOqo4lluffqdzHTa5N9`;
var _15 = `NnQunEmKA6U2q6b9KHSW`;
export { _15 as "owl-height" };
var _16 = `NW2yF1eMMwUNRoC7_rxi`;
export { _16 as "owl-lazy" };
var _17 = `CwtzI924oJiPSR9HkJNQ`;
export { _17 as "owl-video-wrapper" };
var _18 = `wy8hu_64Gnr9hFUrOdZ8`;
export { _18 as "owl-video-play-icon" };
var _19 = `RdoAZGeSJrcnhV0L_4U8`;
export { _19 as "owl-video-playing" };
var _1a = `kCfjmK1m4zcKS7GlfPyD`;
export { _1a as "owl-video-tn" };
var _1b = `pUWxxEZ962T5GBqLGgay`;
export { _1b as "owl-video-frame" };
export default ___CSS_LOADER_EXPORT___;
